import { cn } from '@/utils/tailwind-util';

import Dropdown from '@/components/Dropdown';

import { MENU_LIST } from '../constant';

/**
 *
 * Nav 우측에 위치한 유저 정보 적힌 메뉴
 */

const UserSideList = ({ onRedirect }) => (
  <ul>
    {MENU_LIST.map((list) => (
      <Dropdown.Item
        as="li"
        key={list.id}
        onClick={() => onRedirect(list)}
        className="w-full"
      >
        {({ focused, disabled }) => (
          <button
            type="button"
            disabled={disabled}
            className={cn(
              'w-full px-4 py-2 flex items-center',
              focused && 'text-primary bg-gray-100',
              disabled && 'pointer-events-none'
            )}
          >
            <span>{list.icon && list.icon}</span>
            {list?.label || list?.name}
          </button>
        )}
      </Dropdown.Item>
    ))}
  </ul>
);

export default UserSideList;
